import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { upperFirst } from 'lodash';
import { CountriesService } from '@services/countries/countries.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-shipping-address',
    templateUrl: './shipping-address.component.html',
    styleUrls: ['./shipping-address.component.scss'],
})
export class ShippingAddressComponent implements OnChanges {
    @Input() patient: any;
    @Output() incompleteChange = new EventEmitter<boolean>();
    @Output() shippingInformationChange = new EventEmitter<any>();

    address = '';
    instructions = '';
    incomplete = false;

    constructor(private countriesService: CountriesService, private translate: TranslateService) {}

    ngOnChanges(): void {
        this.buildAddress();
    }

    private buildAddress(): void {
        const shippingInformation = this.getShippingInformation();
        const addressLines = [shippingInformation.line2, shippingInformation.line0, shippingInformation.line1, shippingInformation.line3];
        const locality = [shippingInformation.zipCode, shippingInformation.city, shippingInformation.countryCode];

        this.instructions = shippingInformation?.parcel?.instructions?.trim() ?? '';
        this.incomplete = ['lastName', 'firstName', 'line2', 'zipCode', 'city', 'countryCode'].some(field => !shippingInformation[field]?.trim());
        this.address = [
            [shippingInformation.firstName, shippingInformation.lastName].filter(Boolean).join(' '),
            addressLines.filter(Boolean).join(', '),
            locality.filter(Boolean).join(' '),
            shippingInformation.deliveredAgainstSignature ? this.translate.instant('inclusion.shippingInformation.deliveredAgainstSignature') : '',
        ]
            .filter(Boolean)
            .join('\n');
        this.shippingInformationChange.emit(shippingInformation);
        this.incompleteChange.emit(this.incomplete);
    }

    private getShippingInformation(): any {
        const address = this.patient?.address ?? {};
        const phones = this.patient?.phones ?? {};
        const mobileNumber = phones.first;
        const phoneNumber = phones.second;
        const email = this.patient?.email;
        const defaultShippingInformation = {
            sendMobileNumber: Boolean(mobileNumber),
            sendPhoneNumber: Boolean(phoneNumber),
            sendEmail: Boolean(email),
            lastName: this.formatRecipientName(this.patient?.lastName),
            firstName: this.formatRecipientName(this.patient?.firstName),
            line2: [address.number, address.street].filter(Boolean).join(' '),
            line3: this.patient?.addressComplement,
            zipCode: address.zipCode,
            city: address.city,
            countryCode: this.countriesService.getCountryCode(address.country),
            mobileNumber,
            phoneNumber,
            email,
            parcel: {},
        };
        const currentShippingInformation = this.patient?.shippingInformation ?? {};

        return {
            ...defaultShippingInformation,
            ...currentShippingInformation,
            lastName: currentShippingInformation.lastName ?? defaultShippingInformation.lastName,
            firstName: currentShippingInformation.firstName ?? defaultShippingInformation.firstName,
            line2: currentShippingInformation.line2 ?? defaultShippingInformation.line2,
            line3: currentShippingInformation.line3 ?? defaultShippingInformation.line3,
            zipCode: currentShippingInformation.zipCode ?? defaultShippingInformation.zipCode,
            city: currentShippingInformation.city ?? defaultShippingInformation.city,
            countryCode: currentShippingInformation.countryCode ?? defaultShippingInformation.countryCode,
            parcel: {
                ...defaultShippingInformation.parcel,
                ...currentShippingInformation.parcel,
            },
        };
    }

    private formatRecipientName(name?: string): string | undefined {
        return name ? upperFirst(name.toLowerCase()) : name;
    }
}
